export default class VideoDataRelatedVideo {
  private _videoId: string;
  private _title: string;
  private _thumbnailUrl: string;
  private _duration: number;
  private _playerId?: string;
  
  constructor(videoId: string, title: string, thumbnailUrl: string,
      duration: number, playerId?: string) {
    
    this._videoId = videoId;
    this._title = title;
    this._thumbnailUrl = thumbnailUrl;
    this._duration = duration;
    this._playerId = playerId;
  }

  public get videoId(): string {
    return this._videoId;
  }
  public get title(): string {
    return this._title;
  }
  public get thumbnailUrl(): string {
    return this._thumbnailUrl;
  }
  public get duration(): number {
    return this._duration;
  }
  public get playerId(): string|undefined {
    return this._playerId;
  }
}